import { getPaymentMethods, linePayRequest, linePayConfirm, linePayCancel } from '@/services/api.service';

// 定義支付方式類型常數
const PAYMENT_METHOD_TYPE = Object.freeze({
    LINE_PAY: 1,
    // 可以新增其他支付方式...
});

// 定義訂單來源位元位置常數
const ORDER_SOURCE_BIT_POSITION = Object.freeze({
    ONLINE: 1,
    // 可以新增其他位置...
});

export default {
    namespaced: true,
    state: {
        page: 0,
        page_size: 10,
        paymentMethodsList: [],
        paymentUrl: ''
    },
    getters: {
        linePayPaymentMethod: (state, getters) => {
            const linePayPaymentMethod = state.paymentMethodsList.find(paymentMethod => paymentMethod.payment_method_type === PAYMENT_METHOD_TYPE.LINE_PAY);
            if (!linePayPaymentMethod) {
                return null
            }
            if (getters.isOnlineOrderEnabled(linePayPaymentMethod)) {
                return linePayPaymentMethod;
            }
            // 如果找不到符合條件的支付方式，則返回 null
            return null;
        },
        isOnlineOrderEnabled: (state, getters) => (paymentMethod) => {
            const enabled = paymentMethod.enabled === 1;
            if (!enabled) {
                return false;
            }

            return getters.isFunctionEnabled(paymentMethod.order_source_switch, ORDER_SOURCE_BIT_POSITION.ONLINE);
        },
        isFunctionEnabled: () => (decimal, bitPosition) => {
            // 使用 bit 位數判斷十進位值在二進位值的 value
            if (decimal === undefined) return false
            return (decimal & (1 << bitPosition)) !== 0;
        },
    },
    mutations: {
        setPaymentMethods(state, payload) {
            state.paymentMethodsList = payload;
        },
        setPaymentUrl(state, payload) {
            state.paymentUrl = payload;
        }
    },
    actions: {
        async getPaymentMethods({ commit }) {
            const paymentMethodsResponse = (await getPaymentMethods()).data.data
            console.log('paymentMethodsResponse', paymentMethodsResponse);
            if (paymentMethodsResponse.msg !== 'Success') {
                throw (paymentMethodsResponse.err_msg)
            }
            commit('setPaymentMethods', paymentMethodsResponse.payment_methods_config_info_list);
        },
        async linePayRequest({ commit }, data) {
            const linePayRequestResponse = (await linePayRequest(data)).data.data;
            console.log('linePayRequestResponse', linePayRequestResponse);
            if (linePayRequestResponse.msg !== 'Success') {
                throw (linePayRequestResponse.err_msg)
            }
            commit('setPaymentUrl', linePayRequestResponse.paymentUrl);
        },
        async linePayConfirm(context, data) {
            const linePayConfirmResponse = (await linePayConfirm(data)).data.data;
            console.log('linePayConfirmResponse', linePayConfirmResponse);
            if (linePayConfirmResponse.msg !== 'Success') {
                console.error('linePayConfirmResponse', linePayConfirmResponse.err_msg);
            }
        },
        async linePayCancel(data) {
            const linePayCancelResponse = await linePayCancel(data);
            console.log('linePayCancelResponse', linePayCancelResponse);
            if (linePayCancelResponse.msg !== 'Success') {
                throw (linePayCancelResponse.err_msg)
            }
        }
    }
}